export const featuresCards = [
  {
    title: "Financial Advisors",
    description: "Chat with financial advisors who can help you build a plan for your future",
    imageSrc: "/assets/onboarding-interests/advise.png",
  },
  {
    title: "Tax Savings",
    description: "Automate your tax savings and payments, while earning additional income on those savings.",
    imageSrc: "/assets/onboarding-interests/tax.png",
  },
  {
    title: "Expense Management",
    description: "Keep track of your business expenses and tax deducations with ease.",
    imageSrc: "/assets/onboarding-interests/expense.png",
  },
  {
    title: "Retirement Plans",
    description: "Find pre-tax deductions and contribute to your IRA or Solo401K for long term financial growth.",
    imageSrc: "/assets/onboarding-interests/retirement.png",
  },
  {
    title: "HSA (Health Savings Accounts)",
    description: "Take advantange of your pre-tax deductions with an HSA. Use it for qualified medical expenses.",
    imageSrc: "/assets/onboarding-interests/hsa.png",
  },
  {
    title: "Income Tracking",
    description: "Gain a clear view into your income for effective tax management and retirement planning.",
    imageSrc: "/assets/onboarding-interests/income-tracking.png",
  },
];
